import { Button, Col, DatePicker, Form, Input, notification, Row, Select } from "antd";
import { API_DATE_FORMAT, API_ERR_MESSAGE, DATE_FORMAT, EMAIL_PATTERN, PASSWORD_RULES, PHONE_PATTERN } from "../../../../config/constant";
import moment from "moment";
import { useEffect } from "react";
import { addClientApi, clientDuplicateCheckApi, listOfClientApi, listOfProgramApi, listOfUsersApi, updateClientApi } from "../../../../config/Api";
import { apiErrorMessage } from "../../../../services/ApiError";
import { useState } from "react";
import { FilterApiData } from "../../../../services/FilterApiData";

export const UpdateClientDetail = (props) => {
    let date_format = 'DD/MM/YYYY'
    // console.log(props.editPatientRecord);
    if (props.buttonName == 'UPDATE') {
        // const { email, mobile, name, program, nutritionist, startDate, phenoType, whatsappNo, expiresOn } = props.editPatientRecord;
    }
    const [form] = Form.useForm();
    const { Option } = Select;
    const [programOptions, setProgramOptions] = useState([])
    const [selectedProgram, setSelectedProgram] = useState('')
    const [nutritionistType, setNutritionistType] = useState('');
    const [selectedProgramData, setselectedProgramData] = useState()
    // const [programStartDate, setProgramStartDate] = useState('')
    const [updatePatientList, setUpdatePatientList] = useState(false)
    const [loading, setLoading] = useState(false)
    const [activePatientList, setActivePatientList] = useState([])
    const [patientList, setPatientList] = useState([])
    const [totalActiveClientLimit, setTotalActiveClientLimit] = useState(0)
    // true while the client is being saved (saving also sends the verification email, which takes a few seconds)
    const [saving, setSaving] = useState(false)


    const resetData = () => {
        form.resetFields()
    };

    // get the list of all programs
    //==============================
    const getlistProgram = () => {
        listOfProgramApi()
            .then((res) => {
                if (res.status === 200) {
                    setProgramOptions(FilterApiData(res.data.data));
                    // console.log(res.data.data);
                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    useEffect(() => {
        if (props.buttonName == "Add") {
            // console.log("add calleed");
            resetData()
        }
        getlistProgram()
    }, [props.buttonName])
    // console.log("props.editPatientRecord", props?.editPatientRecord?.status);
    useEffect(() => {
        if (props.buttonName == "UPDATE") {
            let todayDate = new Date()
            let record = props.editPatientRecord
            // console.log(moment(record.start_date).format(API_DATE_FORMAT));
            form.setFieldsValue({
                email: record.email || '',
                mobile: record.mobile || '',
                name: record.name || '',
                program: record.program_id || '',
                nutritionist: record.email || '',
                start_date_of_plan: moment(record.start_date, API_DATE_FORMAT),
                phenoType: record.phenotype_status.toString(),
                whatsapp_number: record.whatsapp_number || '',
                reasonForContact: record?.reasonForContact || '',
                expiresOn: record.end_date ? moment(record.end_date, API_DATE_FORMAT) : null
            });
            setselectedProgramData(record?.program_id)
        }
    }, [props.editPatientRecord])

    useEffect(() => {
        if (selectedProgram) {
            updateProgram(selectedProgram)
        }
    }, [selectedProgram])

    useEffect(() => {
        let NutritionistType = JSON.parse(localStorage.getItem('user'))
        setNutritionistType(NutritionistType?.user?.type_of_account)

        if (NutritionistType?.user?.type_of_account) {
            if (NutritionistType?.user?.type_of_account !== 'Nutritionist (Ayurveda)') {
                form.setFieldValue('phenoType', 'false')
            }
        }


    }, [])

    useEffect(() => {
        getListOfPatient()
        getListOfUsers()
    }, [updatePatientList])
    // get the selected program record data from its selected program
    //==============================
    const updateProgram = (selectdProgramOption) => {

        let programOptionsList = programOptions
        let programRecord = programOptionsList.find((option) => option.id == selectdProgramOption)
        // console.log(programRecord);
        setselectedProgramData(programRecord);
        setUpdatePatientList(!updatePatientList)
        // if start date is available and program is change then update end date based om program duration days  
        // if (form.getFieldValue('start_date_of_plan')) {
        //     findProgramEndDate(form.getFieldValue('start_date_of_plan'))
        // }
    }

    // when user select start date then add no of days available in selected program duration that is end date 
    //==============================
    const findProgramEndDate = (startDate) => {
        // console.log('startDate', startDate);
        if (startDate != null) {
            let endDate = moment(startDate, API_DATE_FORMAT).add(parseInt(selectedProgramData?.duration), 'd');
            // console.log('endDate', endDate);
            form.setFieldValue('expiresOn', moment(endDate, API_DATE_FORMAT))
        }
    }

    // get List of Patient List
    //==============================
    const getListOfPatient = () => {
        setLoading(true)

        listOfClientApi()
            .then((res) => {
                if (res.status === 200) {
                    // set data of those users whose status is ACTIVE
                    if (res?.data?.data) {
                        if (res?.data?.data?.length > 0) {
                            setActivePatientList(FilterApiData(res.data.data));
                            setPatientList(res.data.data);
                            // console.log(FilterApiData(res.data.data).length);
                        }
                    }
                }
                setLoading(false)
            })
            .catch((err) => {
                // console.log("err--", err);
                setLoading(false)
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // get the list of all nutritionist data to get user plan and active client limit
    //=================================
    const getListOfUsers = () => {
        setLoading(true)

        listOfUsersApi()
            .then((res) => {
                if (res.status === 200) {
                    const nutritionistData = FilterApiData(res.data.data);
                    if (nutritionistData && nutritionistData?.length > 0) {
                        let userId = localStorage.getItem('id')
                        // get the login user data by its userid
                        const loginUserData = nutritionistData.find((element) => element.id == userId);
                        // console.log("total patient limit of user plan", loginUserData?.plan?.active_clients);
                        setTotalActiveClientLimit(loginUserData?.plan?.active_clients)
                    }
                }
                setLoading(false)

            })
            .catch((err) => {
                setLoading(false)

                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // handle submit 
    // check with the server that the doctor has no other client with this email / mobile
    // (the save itself still refuses duplicates, so a failed check is ignored)
    //==============================
    const validateNotDuplicate = (field) => async (_, value) => {
        if (!(value || '').trim()) return

        let res
        try {
            res = await clientDuplicateCheckApi({ [field]: value, ignore_id: props.editPatientRecord?.id })
        } catch (err) {
            return
        }
        const message = res?.data?.errors?.[field]?.[0]
        if (message) {
            throw new Error(message)
        }
    }

    // show the server's field errors (like a duplicate email) under the fields
    //==============================
    const onSaveError = (err) => {
        const errors = err?.response?.data?.errors
        if (errors && typeof errors === 'object') {
            form.setFields(Object.entries(errors)
                .filter(([name]) => ['name', 'email', 'mobile', 'whatsapp_number', 'password'].includes(name))
                .map(([name, messages]) => ({ name, errors: [].concat(messages) })))
        }
        notification.error({
            message: apiErrorMessage(err),
        });
    }

    //==============================
    const onFinish = (values) => {
        // const data = {
        //     "name": "shrey dhingani",
        //     "email": "shrey19396@gmail.com",
        //     "password": "123456",
        //     "mobile": "9099885205",
        //     "whatsapp_number": "9099885205",
        //     "program_id": 2,
        //     "plan_start": "24-12-2022",
        //     "plan_end": "24-12-2023",
        //     "status": true,
        //     "phenotype_status": false
        // }
        // console.log("values", values);
        let data;

        if (props.buttonName == 'Add') {
            if (activePatientList && activePatientList.length >= totalActiveClientLimit) {
                data = {
                    "name": values.name,
                    "email": values.email,
                    "password": values?.password ? values?.password : '',
                    "mobile": values.mobile,
                    "whatsapp_number": values.whatsapp_number,
                    "program_id": values.program,
                    "start_date": moment(values.start_date_of_plan).format(API_DATE_FORMAT),
                    "end_date": values.expiresOn ? moment(values.expiresOn).format(API_DATE_FORMAT) : '',
                    "status": false,

                    // "phenotype_status":  values.phenoType 
                    "phenotype_status":
                        nutritionistType !== 'Nutritionist (Ayurveda)' ?
                            false :
                            values.phenoType,
                    "reasonForContact": values.reasonForContact ? values.reasonForContact : '',
                }
            } else {
                data = {
                    "name": values.name,
                    "email": values.email,
                    "password": values?.password ? values?.password : '',
                    "mobile": values.mobile,
                    "whatsapp_number": values.whatsapp_number,
                    "program_id": values.program,
                    "start_date": moment(values.start_date_of_plan).format(API_DATE_FORMAT),
                    "end_date": values.expiresOn ? moment(values.expiresOn).format(API_DATE_FORMAT) : '',
                    "status": true,

                    // "phenotype_status":  values.phenoType 
                    "phenotype_status":
                        nutritionistType !== 'Nutritionist (Ayurveda)' ?
                            false :
                            values.phenoType,
                    "reasonForContact": values.reasonForContact ? values.reasonForContact : '',
                }
            }
        } else {
            data = {
                "name": values.name,
                "email": values.email,
                "password": values?.password ? values?.password : '',
                "mobile": values.mobile,
                "whatsapp_number": values.whatsapp_number,
                "program_id": values.program,
                "start_date": moment(values.start_date_of_plan).format(API_DATE_FORMAT),
                "end_date": values.expiresOn ? moment(values.expiresOn).format(API_DATE_FORMAT) : '',
                "status": props?.editPatientRecord ? props?.editPatientRecord?.status : false,

                // "phenotype_status":  values.phenoType 
                "phenotype_status":
                    nutritionistType !== 'Nutritionist (Ayurveda)' ?
                        false :
                        values.phenoType,
                "reasonForContact": values.reasonForContact ? values.reasonForContact : '',

            }
        }
        // const data = {
        //     "name": values.name,
        //     "email": values.email,
        //     "password": values?.password ? values?.password : '',
        //     "mobile": values.mobile,
        //     "whatsapp_number": values.whatsapp_number,
        //     "program_id": values.program,
        //     "start_date": moment(values.start_date_of_plan).format(API_DATE_FORMAT),
        //     "end_date": values.expiresOn ? moment(values.expiresOn).format(API_DATE_FORMAT) : '',
        //     "status": props?.editPatientRecord ? props?.editPatientRecord?.status : false,

        //     // "phenotype_status":  values.phenoType 
        //     "phenotype_status":
        //         nutritionistType !== 'Nutritionist (Ayurveda)' ?
        //             false :
        //             values.phenoType,
        //     "reasonForContact": values.reasonForContact ? values.reasonForContact : '',

        // }
        // if (values.phenoType) {
        //     data.phenotype_status = values.phenoType;
        // }
        // if (values.phenoType) {
        //     Object.assign(data, { "phenotype_status": values.phenoType })
        // }

        // console.log("props.buttonName", props.buttonName, values, data);
        setSaving(true)
        if (props.buttonName == 'Add') {
            addClientApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: res.data.message || "Patient Detail added successfully",
                        });
                        props.getListOfPatient()
                        props.setIsModalVisible(false)
                        setUpdatePatientList(!updatePatientList)
                    }
                })
                .catch(onSaveError)
                .finally(() => setSaving(false));
        }
        else {

            updateClientApi(props.editPatientRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        props.setButtonName("Add")
                        notification.success({
                            message: res.data.message || "Patient Detail Update successfully",
                        });
                        props.getListOfPatient()
                        props.setIsModalVisible(false)
                        setUpdatePatientList(!updatePatientList)
                    }
                })
                .catch(onSaveError)
                .finally(() => setSaving(false));
        }
    };
    return (
        <div className="UpdateClientDetail">

            <Form
                name="UpdateClientDetail"
                className="UpdateClientDetail"
                form={form}
                onFinish={onFinish}
            >
                <div className="logoSection">
                    <h4 className="mb-0">{props.buttonName == "Add" ? "Add" : "Edit"} Client Details</h4>
                </div>
                <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3" >
                    <Col xs={24} md={16} xl={11} xxl={12}>
                        <label className="form-input-label">
                            Name
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="name"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Name!",
                                },
                            ]}
                        // initialValue={name}
                        >
                            <Input placeholder="Enter Name" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={12}>
                        <label className="form-input-label">
                            Email
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="email"
                            rules={[
                                { required: props.buttonName == "Add" ? true : false, message: "Please insert Email!" },
                                {
                                    pattern: EMAIL_PATTERN,
                                    message: "Please insert valid data!",
                                },
                                {
                                    // tell the doctor about a duplicate when they leave the field, not only on save
                                    validateTrigger: 'onBlur',
                                    validator: validateNotDuplicate('email'),
                                },
                            ]}
                            validateTrigger={['onChange', 'onBlur']}
                        >
                            <Input placeholder="Enter Email ID" disabled={props.buttonName == "UPDATE" ? true : false} className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={12}>

                        <label className="form-input-label">
                            Phone
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="mobile"
                            // initialValue={mobile}
                            rules={[
                                { required: true, message: "Please insert Mobile No!" },
                                {
                                    pattern: PHONE_PATTERN,
                                    message: "Please insert valid data!",
                                },
                                {
                                    validateTrigger: 'onBlur',
                                    validator: validateNotDuplicate('mobile'),
                                },
                            ]}
                            validateTrigger={['onChange', 'onBlur']}
                        >
                            <Input maxLength={10} placeholder="Enter Phone No" disabled={props.buttonName == "UPDATE" ? true : false} className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={12}>
                        <label className="form-input-label">
                            Password
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="password"
                            validateFirst
                            rules={[
                                // { required: props.buttonName == "Add" ? true : false, message: "Please insert Password!" },
                                { required: false, message: "Please insert Password!" },
                                ...PASSWORD_RULES,
                                // {
                                //     pattern: EMAIL_PATTERN,
                                //     message: "Please insert valid data!",
                                // },
                            ]}
                        >
                            <Input.Password placeholder="Enter Password" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={12}>

                        <label className="form-input-label">
                            Program
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="program"
                            // initialValue={program}
                            rules={[{ required: true, message: "Please Select Program!" }]}
                            initialValue=""
                        >

                            <Select
                                className="w-100 mt-2"
                                // value={regType}
                                // defaultValue=""
                                onChange={(e) => { setSelectedProgram(e); updateProgram(e) }}
                            >
                                <Option value="" disabled hidden>
                                    Select Program
                                </Option>
                                {
                                    programOptions && programOptions.length > 0 && programOptions.map((option, index) =>
                                        <Option key={index} value={option.id}>{option.name}</Option>
                                    )
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    {/* <Col xs={24} md={16} xl={11} xxl={12}>

                        <label className="form-input-label">
                            Select Nutritionist
                        </label>
                        <Form.Item
                            name="select_nutritionist"
                        // initialValue={nutritionist}
                        // rules={[{ required: true, message: "Please insert Price!" }]}
                        >
                            <Select
                                className="mt-2"
                                // value={regType}
                                defaultValue=""
                            // onChange={(e) => setRegType(e)}
                            >
                                <Option value="" disabled hidden>
                                    Select Nutritionist
                                </Option>
                                <Option value="Krunal Patadiya">Krunal Patadiya</Option>
                                <Option value="Prakash Gujarati">Prakash Gujarati</Option>
                                <Option value="Mansi Bhojani">Mansi Bhojani</Option>
                            </Select>
                        </Form.Item>
                    </Col> */}
                    <Col xs={24} md={16} xl={11} xxl={12}>

                        <label className="form-input-label">
                            Plan Start Date
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="start_date_of_plan"
                            rules={[{ required: true, message: "Please Select Start Date!" }]}
                        >
                            <DatePicker
                                // key={`${startDate}`}
                                // defaultValue={
                                //     startDate !== ""
                                //         ? moment(startDate)
                                //         : undefined
                                // }
                                // onChange={(value: any, dateString: any) => setEntryDate(dateString)}
                                format={API_DATE_FORMAT}
                                // disabled={selectedProgram && form.getFieldValue('start_date_of_plan') ? false : true}
                                className="w-100 mt-2 p-2"
                            // onChange={(e) => findProgramEndDate(e)}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={12}>

                        <label className="form-input-label">
                            Plan End Date
                            <span className="asterik"> *</span>
                        </label>
                        <Form.Item
                            name="expiresOn"
                            rules={[{ required: false, message: "Please Select End Date!" }]}
                        >
                            <DatePicker
                                // key={`${expiresOn}`}
                                // defaultValue={
                                //     expiresOn !== ""
                                //         ? moment(expiresOn)
                                //         : undefined
                                // }
                                // onChange={(value: any, dateString: any) => setEntryDate(dateString)}
                                format={API_DATE_FORMAT}
                                className="w-100 mt-2 p-2"

                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={12}>

                        <label className="form-input-label">
                            Whatspp Number
                            {/* <span className="asterik"> *</span> */}
                        </label>
                        <Form.Item
                            name="whatsapp_number"
                            // initialValue={whatsappNo}
                            rules={[
                                { required: true, message: "Please insert WhatsApp No!" },
                                {
                                    pattern: PHONE_PATTERN,
                                    message: "Please insert valid data!",
                                },
                            ]}
                        >
                            <Input placeholder="Enter Whatspp No" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={12}>
                        {/* {console.log("nutritionistType", nutritionistType)} */}
                        <span
                            style={{
                                display:
                                    // nutritionistType !== "Nutritionist (Ayurveda)" && 'none'
                                    nutritionistType !== "Nutritionist (Ayurveda)" ? 'none' : 'block'
                            }}
                        >
                            <label className="form-input-label">
                                Phenotype
                            </label>
                            <Form.Item
                                name="phenoType"
                                rules={[{ required: nutritionistType !== 'Nutritionist (Ayurveda)' ? false : true, message: "Please select PhenoType!" }]}
                                initialValue=""
                            >
                                <Select
                                    className="mt-2"
                                // value={regType}
                                // defaultValue={phenoType ? phenoType : ""}
                                // onChange={(e) => setRegType(e)}
                                >
                                    <Option value="" disabled hidden>
                                        Select Phenotype
                                    </Option>
                                    <Option value="true">Enable</Option>
                                    <Option value="false">Disable</Option>
                                </Select>
                            </Form.Item>
                        </span>
                    </Col>
                    <Col xs={24} md={16} xl={11} xxl={12}>

                        <label className="form-input-label">
                            Reason For Contact
                        </label>
                        <Form.Item
                            name="reasonForContact"
                            rules={[
                                { required: false, message: "Please insert Reason For Contact!" },
                            ]}
                        >
                            <Input.TextArea placeholder="Enter Reason For Contact" className="mt-2 p-2" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={24} xl={24} xxl={24} className="text-end align-items-center align-self-center">
                        <Button htmlType="submit" loading={saving} className="submit-button b-0 rounded">
                            {props.buttonName == "Add" ? (saving ? "SAVING" : "SAVE") : (saving ? "UPDATING" : "UPDATE")}
                        </Button>
                        <Button onClick={() => resetData()} disabled={saving} className="reset-button ms-4 b-0 rounded">
                            RESET
                        </Button>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

